import { render } from "./ContentBlock.vue?vue&type=template&id=74ed4bb3&scoped=true&ts=true"
import script from "./ContentBlock.ts?vue&type=script&lang=ts"
export * from "./ContentBlock.ts?vue&type=script&lang=ts"

import "./ContentBlock.vue?vue&type=style&index=0&id=74ed4bb3&scoped=true&lang=css"

import exportComponent from "/app/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74ed4bb3"]])

export default __exports__